import { t, tf } from '../i18n/index.ts'

export const TEMP_CHAT_FALLBACK_MS = 24 * 60 * 60 * 1000

const DURATION_KEYS: ReadonlyArray<{ key: string; ms: number }> = [
  { key: 'temp_duration_5m', ms: 5 * 60 * 1000 },
  { key: 'temp_duration_10m', ms: 10 * 60 * 1000 },
  { key: 'temp_duration_15m', ms: 15 * 60 * 1000 },
  { key: 'temp_duration_30m', ms: 30 * 60 * 1000 },
  { key: 'temp_duration_1h', ms: 60 * 60 * 1000 },
  { key: 'temp_duration_6h', ms: 6 * 60 * 60 * 1000 },
  { key: 'temp_duration_24h', ms: 24 * 60 * 60 * 1000 },
  { key: 'temp_duration_7d', ms: 7 * 24 * 60 * 60 * 1000 },
]

/** Duration options; `label` resolves via current locale. */
export const TEMP_CHAT_DURATIONS: ReadonlyArray<{ label: string; ms: number }> = DURATION_KEYS.map((d) => ({
  get label() {
    return t(d.key)
  },
  ms: d.ms,
}))

export function buildTempChatKey(sessionA: string, sessionB: string): string {
  return [sessionA.trim(), sessionB.trim()].filter(Boolean).sort().join('_')
}

export function tempChatMessageContactId(chatKey: string): string {
  const k = chatKey.trim()
  if (k.startsWith('temp:')) return k
  return `temp:${k}`
}

/** ID per badge non letti / chat attiva — separato dalla chat normale. */
export function tempChatUnreadId(chatKey: string): string {
  return `temp-unread:${chatKey.trim()}`
}

export function isTempChatMessageContactId(contactId: string): boolean {
  return contactId.trim().startsWith('temp:')
}

export function formatTempRemaining(remainingMs: number): string {
  if (remainingMs <= 0) return t('temp_remaining_expired')
  const days = Math.floor(remainingMs / 86_400_000)
  const hours = Math.floor((remainingMs % 86_400_000) / 3_600_000)
  const minutes = Math.floor((remainingMs % 3_600_000) / 60_000)
  const seconds = Math.floor((remainingMs % 60_000) / 1000)
  if (days > 0) return tf('temp_remaining_days', { days, hours })
  if (hours > 0) return tf('temp_remaining_hours', { hours, minutes })
  if (minutes > 0) return tf('temp_remaining_minutes', { minutes })
  return tf('temp_remaining_seconds', { seconds })
}
